module.exports = __webpack_public_path__ + "static/media/SPEAKING.dd63f8d1.png";